import { render, staticRenderFns } from "./SummaryChart.vue?vue&type=template&id=4553057e&scoped=true&"
import script from "./SummaryChart.vue?vue&type=script&lang=js&"
export * from "./SummaryChart.vue?vue&type=script&lang=js&"
import style0 from "./SummaryChart.vue?vue&type=style&index=0&id=4553057e&lang=scss&scoped=true&"
import style1 from "./SummaryChart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553057e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
